import {useMemo} from "react";
import {DataTableColumn} from "mantine-datatable";
import {MeterAssignment} from "../types.ts";
import {I18n} from "@aws-amplify/core";
import {StatusBadge} from "../profile/StatusBadge.tsx";
import {formatTimestamp} from "../../../utils/TableTimestamps.tsx";
import {useCustomers} from "../../customers/hooks/useCustomers.ts";
import {Customer} from "../../customers/types.ts";
import {customerLabelById} from "../../customers/utils/customerLabel.ts";

export const useTableColumns = () => {

    // FNP-773: resolve customerId → a human label instead of printing the raw
    // UUID. Build a lookup from the loaded customers; unresolved ids fall back to
    // a shortened id inside customerLabelById.
    const {items: customers} = useCustomers();
    const customersById = useMemo(
        () => new Map<string, Customer>((customers || []).map((c: Customer) => [c.id, c])),
        [customers],
    );

    const columns: DataTableColumn<MeterAssignment>[] = [
        {
            accessor: 'customerId',
            title: I18n.get('Customer'),
            width: '1fr',
            render: (item: MeterAssignment) => customerLabelById(item.customerId, customersById),
        },
        {
            accessor: 'meterId',
            title: I18n.get('Meter'),
            width: '1fr',
            render: (item: MeterAssignment) => item.meterId,
        },
        {
            accessor: 'channel',
            title: I18n.get('Channel'),
            width: '1fr',
            render: (item: MeterAssignment) => item.channel,
        },
        {
            accessor: 'freeTierQuantity',
            title: I18n.get('Free Tier'),
            width: '1fr',
            render: (item: MeterAssignment) => item.freeTierQuantity ?? '-',
        },
        {
            accessor: 'status',
            title: I18n.get('Status'),
            width: '1fr',
            render: (item: MeterAssignment) => <StatusBadge status={item.status}/>,
        },
        {
            accessor: 'effectiveFrom',
            title: I18n.get('Effective From'),
            width: '1fr',
            render: (item: MeterAssignment) => formatTimestamp(item.effectiveFrom),
        },
        {
            accessor: 'created',
            title: I18n.get('Created'),
            width: '1fr',
            render: (item: MeterAssignment) => formatTimestamp(item.created),
        },

    ];

    return {
        columns,
    }
}
